import { DepartmentActions, EntityActions } from "~/apps/shared/actions/consts";

type DepartmentUIState = {
  currentList: string[];
  loading: boolean;
  errorMessage: string;
}

type DepartmentState = {
  entities: {};
  ui: DepartmentUIState;
}

export function departments(
  state = {
    entities: {},
    ui: {
      currentList: [],
      loading: false,
      errorMessage: ''
    }
  } as DepartmentState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.departments,
        }
      }
    case DepartmentActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case DepartmentActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        },
      };
    case DepartmentActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case DepartmentActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentList: action.result,
          loading: false,
          errorMessage: '',
        },
      };
    default:
      return state;
  }
}
